import { Component, OnInit } from '@angular/core';
import { LoginService } from '../login.service';
import { Message } from 'primeng/primeng';
import { NgForm } from '@angular/forms';
import { GlobalDataService } from '../../services/global-data.service';
import { Router } from '@angular/router';



@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [LoginService]
})
export class LoginComponent implements OnInit {

	button_caption="Вход";	
	msgs: Message[] = [];
  _loading: boolean = false;
  _indicator: boolean = false;
  obj={};
  fValue: NgForm;

  constructor(
    private loginService: LoginService, 
    private global: GlobalDataService,
    private router: Router) {
     
  }

  ngOnInit() {
  // this.click();  //auto
  }

 // click(){  //auto
  click(form?: NgForm){
     this.global.user={id: "", username: "", email: "", password: "", password_confirmation: "", contacts: { full_name: ""}, stores: [], available: ""};
     
 
     this._loading=true;
     // this.loginService.postData(this.obj)  //auto
          console.log('omad');
  	  this.loginService.auth(form.value)
  	  // this.loginService.auth(this.obj)
                .subscribe(
                  (data) => {
                       localStorage.setItem('token', data['token']);
                       this.global.user=data['user'];
                       this.global.permissions=[];
                       for(var item of this.global.user.roles){
                          for (var permission of item.permissions ){
                            this.global.permissions[permission.name]=1;
                          }
                       }
                       console.log(this.global.permissions);
                       console.log(this.global.user);
                       if(this.global.permissions['operations']){
                           this.router.navigate(['/dashboard/operation']);
                       }else if(this.global.permissions['product_storage']){
                           this.router.navigate(['/dashboard/product_storage']);
                       }else{
                        this.router.navigate(['/dashboard']);
                       }
                  }, 
                  (error)=>{
                        let str="";
                          this._loading=false; 
                          this.msgs=[];
                          this.msgs.push({severity:'error', summary:'Сообщение', detail: "Ошибка: "+error.error.message});
                  });
   
  }

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/login/login/login.component.ts